import APIURLConstants from "../common/ApiURLConstants";
import APIHelper from "../common/ApiHelper";
import { authHeader } from "../helper";

export const CalendarEventServices = {
  getCalendarEventsData,
  addUpdateCalendarEvent,
  deleteCalendarEvent,
};

async function getCalendarEventsData(startDate, endDate) {
  const response = await APIHelper.get(
    `${APIURLConstants.GET_CALENDER_EVENTS}?FromDate=${startDate}&ToDate=${endDate}`,
    authHeader()
  );
  return response;
}

async function addUpdateCalendarEvent(formObj) {
  const response = await APIHelper.post(
    `${APIURLConstants.ADD_UPDATE_CALENDAR_EVENT}`,
    formObj,
    authHeader()
  );
  return response;
}

async function deleteCalendarEvent(EventId, ProcessedBy) {
  const response = await APIHelper.post(
    `${APIURLConstants.DELETE_CALENDAR_EVENT}?EventId=${EventId}&ProcessedBy=${ProcessedBy}`,
    authHeader()
  );
  return response;
}
